import React from 'react'
import { useNavigate } from 'react-router-dom'
import { formatCharacterName } from '../../utils';

const Confirmation = ({ amount, character }) => {
  const navigate = useNavigate();

  return (
    <div className="rounded p-5" style={{backgroundColor: "#0B0E1E", width: "600px", border: "1px solid #E5E5E5"}}>
        <h2 className="text-center mb-4">Thank you for your support!</h2>
        <p className='text-center mb-3'>Your payment has been received. An invoice will be created under your account and you will receive a confirmation email shortly.</p>
        <p className='text-center mb-2'>The amount of ${amount} will go towards:</p>
        <h3 className='text-center'>{formatCharacterName(character)}</h3>
        <div className="text-center mt-4">
            <button className="rounded w-50" style={{backgroundColor: "#FFCC19", height: "45px", fontWeight: 600}} onClick={() => navigate('/')}>Return to Home</button>
        </div>
    </div>
  )
}

export default Confirmation